import React, { useEffect, useState } from 'react';
import BRANDLOGO from '../Assets/images/brand-logo.png';
import PROFILE from '../Assets/images/nav-profile.png';
import NOTIFY from '../Assets/images/nav-notification-icon.png';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import './navbar.css';
import {
  ADD_PROPERTY,
  DASHBOARD,
  HOME,
  MANAGE_TEAM,
  MESSAGES,
  PAYMENT,
  PRICING,
  REQUIREMENTS,
} from '../constants/route-path';
import {
  Avatar,
  Badge,
  Box,
  IconButton,
  Popover,
  Typography,
} from '@mui/material';
import HomeSidebar from './home-sidebar';
import MENU from '../Assets/images/menu.png';
import { useDispatch, useSelector } from 'react-redux';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { IconRosetteDiscountCheckFilled } from '@tabler/icons-react';
import { handleProfileRedirection } from '../constants/enums';
import Notifications from './Notifications';
import apis from '../Services/api-services';
import { userActions } from '../Store/userSlice';
import { useTranslation } from 'react-i18next';
import { TRANSLATIONS } from '../Utils/translations';
import LanguageModal from './LanguageModal';
import { getInitials, isPaymentEnabled } from '../Utils/helperUtils';
import BadgeIcon from '@mui/icons-material/Badge';
import CorporateFareOutlinedIcon from '@mui/icons-material/CorporateFareOutlined';
import PersonIcon from '@mui/icons-material/Person';
import LanguageIcon from '@mui/icons-material/Language';
import GroupsIcon from '@mui/icons-material/Groups';
import FeedbackIcon from '@mui/icons-material/Feedback';
import DeleteIcon from '@mui/icons-material/Delete';
import LogoutIcon from '@mui/icons-material/Logout';
import CurrencyRupeeOutlinedIcon from '@mui/icons-material/CurrencyRupeeOutlined';
import ConfirmDeleteAccountModal from './ConfirmDeleteAccountModal';
import VerifyProfileModal from './verifyProfileModal';
import LoaderComponent from './loader';
import {
  sendAnalyticsEventToServer,
  trackEvent,
  trackGAEvent,
} from '../Utils/analytics';
import { ANALYTICS_CATEGORIES } from '../constants/analytics-events';
import { ANALYTICS_EVENT_NAMES } from '../constants/analytics-events-config';

const Navbar = ({
  handleLogout,
  selectedNavLink,
  setSelectedNavLink,
  totalUnreadCount,
  notificationsCount,
  setNotificationsCount,
}) => {
  const { pathname } = useLocation();
  const { t } = useTranslation();

  const { userName, userId, isUserVerified } = useSelector(
    (state) => state.userDetails || {}
  );
  const { isLoggedIn } = useSelector((state) => state.login || {});

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [openSidebar, setOpenSidebar] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [openNotificationModal, setOpenNotificationModal] = useState(null);
  const [notifications, setNotifications] = useState([]);
  const [openLanguageModal, setOpenLanguageModal] = useState(false);
  const [openDeleteAccountModal, setOpenDeleteAccountModal] = useState(false);
  const [openVerifyProfileModal, setOpenVerifyProfileModal] = useState(false);
  const [profileDetails, setProfileDetails] = useState(null);
  const [loader, setLoader] = useState(false);
  const [currOrg, setCurrOrg] = useState(null);
  const [paymentEnabled, setPaymentEnabled] = useState(false);

  // Check payment enabled status on component mount
  useEffect(() => {
    // const checkPaymentStatus = async () => {
    //   const enabled = await isPaymentEnabled();
    //   setPaymentEnabled(enabled);
    // };
    // checkPaymentStatus();
  }, []);

  const navLinks = [
    {
      title: 'Properties',
      id: 1,
      to: DASHBOARD,
      badge: false,
    },
    {
      title: 'Boosts',
      id: 2,
      to: REQUIREMENTS,
      badge: false,
    },
    {
      title: t(TRANSLATIONS.TITLES.MESSAGES),
      id: 3,
      to: MESSAGES,
      badge: true,
    },
    ...(paymentEnabled ? [{
      title: 'Pricing',
      id: 4,
      to: PRICING,
      badge: false,
    }] : []),
  ];

  const handleClick = (e) => setAnchorEl(e.currentTarget);

  const handleClose = (event) => setAnchorEl(null);

  const handleDrawerToggle = () => setOpenSidebar(true);

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    document.title = notifications?.length
      ? `(${notifications?.length}) AIRA`
      : 'AIRA';
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [notifications]);

  useEffect(() => {
    if (isLoggedIn) {
      getNotifications();
    }
    if (localStorage.getItem('org')) {
      setCurrOrg(JSON.parse(localStorage.getItem('org')));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getNotifications = async () => {
    setIsLoading(true);
    const response = await apis.notification.getNotifications();
    setNotifications(response?.data?.notifications || []);
    setNotificationsCount(response?.data?.notifications?.length || 0);
    setIsLoading(false);
  };

  if (!isLoggedIn) {
    return;
  }

  return (
    <>
      <nav className="navbar">
        <div className="nav-brand">
          <img
            src={BRANDLOGO}
            alt="logo"
            className="nav-brand-img"
            onClick={() => {
              trackGAEvent({
                category: ANALYTICS_CATEGORIES.NAVIGATION,
                action: 'vREfyd_logo_click',
                label: `vREfyd_logo`,
              });
              sendAnalyticsEventToServer(`vREfyd_logo_click`);
              dispatch(userActions.setRecomendationFilters({}));
              navigate(HOME);
            }}
          />
        </div>
        <div className="nav-links-main">
          <div className="nav-links-content">
            {navLinks.map((item) => (
              <NavLink
                index={item.id}
                onClick={() => {
                  trackGAEvent({
                    category: ANALYTICS_CATEGORIES.NAVIGATION,
                    action: item.title,
                    label: `${item.title}`,
                  });
                  sendAnalyticsEventToServer(`navlink_${item.title}`);
                  setSelectedNavLink(item.id);
                  handleClose();
                }}
                to={item.to}
                className={`nav-links ${
                  selectedNavLink === item.id ? 'active-nav-link' : ''
                }`}
              >
                {item.title}{' '}
                {item.badge && (
                  <Badge
                    badgeContent={totalUnreadCount}
                    color="secondary"
                    variant="dot"
                    sx={{
                      marginLeft: '8px',
                      '& .MuiBadge-badge': {
                        background: '#600DB4 !important',
                      },
                    }}
                  >
                    {' '}
                  </Badge>
                )}
              </NavLink>
            ))}
          </div>
        </div>
        <div className="nav-buttons">
          <span
            className="nav-button"
            style={{ position: 'relative' }}
            onClick={() => {
              trackGAEvent({
                category: ANALYTICS_CATEGORIES.NOTIFICATION,
                action: 'notification_click',
                label: `notification_icon`,
              });
              sendAnalyticsEventToServer(`notification_click`);
              getNotifications();
              setOpenNotificationModal((val) => !val);
            }}
          >
            <img src={NOTIFY} width={20} height={20} alt="notification" />

            {notificationsCount > 0 && (
              <span
                style={{
                  position: 'absolute',
                  background: '#600DB4',
                  top: '-8px',
                  right: '-8px',
                  width: '20px',
                  height: '20px',
                  borderRadius: '50%',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  fontSize: '12px',
                  color: '#fff',
                }}
              >
                {notificationsCount}
              </span>
            )}
          </span>

          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 0.5,
              border: `1px solid rgba(213, 220, 229, 1)`,
              padding: '8px 6px',
              borderRadius: '8px',
              marginLeft: '.5rem',
              cursor: 'pointer',
              maxWidth: '50%',
            }}
            onClick={handleClick}
            aria-describedby={id}
          >
            {/* <Avatar src={userName}  sx={{ width: '36px', height: '36px' }} /> */}
            <Avatar
              sx={{
                fontSize: '12px',
                width: '22px',
                height: '22px',
                backgroundColor: 'rgba(96, 13, 180, 0.4)',
                color: '#fff',
              }}
            >
              {getInitials(userName) || ''}
            </Avatar>

            <Typography sx={{ color: '#6C7480', fontSize: '14px' }}>
              {t(userName || '')}
            </Typography>
            <KeyboardArrowDownIcon sx={{ color: '#6C7480' }} />
          </Box>

          <Popover
            id={id}
            transition
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
            sx={{
              '.MuiBox-root': {
                border: 'none',
                borderRadius: '10px',
                boxShadow: '1px 1px 7.3px 0px rgba(185, 185, 185, 0.25)',
                cursor: 'pointer',
              },
            }}
          >
            <Box
              sx={{
                border: 1,
                p: 2,
                bgcolor: 'background.paper',
                cursor: 'pointer',
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                gap: '4px',
              }}
            >
              <BadgeIcon sx={{ color: '#600DB4', marginRight: '8px' }} />
              {t(TRANSLATIONS.TITLES.AGENT_ID)} : {userId}
              {isUserVerified === 'true' && (
                <IconRosetteDiscountCheckFilled
                  color="#600DB4"
                  width={'20px'}
                  height={'20px'}
                />
              )}
            </Box>
            {currOrg && (
              <Box
                sx={{
                  border: 1,
                  p: 2,
                  bgcolor: 'background.paper',
                  width: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '4px',
                }}
              >
                <CorporateFareOutlinedIcon
                  sx={{ color: '#600DB4', marginRight: '6px' }}
                />
                Organisation : {currOrg?.user_company_name}
              </Box>
            )}
            <Box
              onClick={() => {
                trackGAEvent({
                  category: ANALYTICS_CATEGORIES.PROFILE,
                  action: 'navbar_profile_click',
                  label: `profile_navbar`,
                });
                sendAnalyticsEventToServer(`navbar_profile_option_click`);
                handleClose();
                handleProfileRedirection(navigate);
              }}
              sx={{
                border: 1,
                p: 2,
                bgcolor: 'background.paper',
                cursor: 'pointer',
                width: '100%',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <PersonIcon sx={{ color: '#600DB4', marginRight: '8px' }} />
              {t(TRANSLATIONS.TITLES.PROFILE)}
            </Box>
            {/* <Box
              onClick={() => {
                trackGAEvent({
                  category: ANALYTICS_CATEGORIES.PAYMENT,
                  action: 'navbar_payment_click',
                  label: `payment_modal`,
                });
                sendAnalyticsEventToServer(`navbar_payment_click`);
                handleClose();
                navigate(PAYMENT);
              }}
              sx={{
                border: 1,
                p: 2,
                bgcolor: 'background.paper',
                cursor: 'pointer',
                width: '100%',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <CurrencyRupeeOutlinedIcon
                sx={{ color: '#600DB4', marginRight: '8px' }}
              />
              Payment
            </Box> */}
            <Box
              onClick={() => {
                trackGAEvent({
                  category: ANALYTICS_CATEGORIES.LANGUAGE,
                  action: 'navbar_language_click',
                  label: `language_modal`,
                });
                sendAnalyticsEventToServer(`navbar_language_option_click`);
                handleClose();
                setOpenLanguageModal(true);
              }}
              sx={{
                border: 1,
                p: 2,
                bgcolor: 'background.paper',
                cursor: 'pointer',
                width: '100%',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <LanguageIcon sx={{ color: '#600DB4', marginRight: '8px' }} />
              {t(TRANSLATIONS.TITLES.LANGUAGE)}
            </Box>
            <Box
              onClick={() => {
                trackGAEvent({
                  category: ANALYTICS_CATEGORIES.LANGUAGE,
                  action: 'navbar_manage_team_click',
                  label: `manage_team`,
                });
                sendAnalyticsEventToServer(`navbar_manage_team_click`);
                handleClose();
                navigate(MANAGE_TEAM);
              }}
              sx={{
                border: 1,
                p: 2,
                bgcolor: 'background.paper',
                cursor: 'pointer',
                width: '100%',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <GroupsIcon sx={{ color: '#600DB4', marginRight: '8px' }} />
              Manage Team
            </Box>

            <Box
              onClick={() => {
                trackGAEvent({
                  category: ANALYTICS_CATEGORIES.FEEDBACK,
                  action: 'navbar_airtable_feedback_click',
                  label: `airtable_feedback`,
                });
                sendAnalyticsEventToServer(`navbar_airtable_feedback_click`);
                handleClose();
                window.open(
                  'https://airtable.com/embed/appYSVKAFJ9TqK3q1/pagDIOsuVcgNnNbjt/form',
                  '_blank'
                );
              }}
              sx={{
                border: 1,
                p: 2,
                bgcolor: 'background.paper',
                cursor: 'pointer',
                width: '100%',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <FeedbackIcon sx={{ color: '#600DB4', marginRight: '8px' }} />
              {t(TRANSLATIONS.TITLES.SHARE_FEEDBACK)}
            </Box>

            {window.location.hostname !== 'aira.vrefyd.com' && (
              <Box
                onClick={() => {
                  handleClose();
                  setOpenDeleteAccountModal(true);
                }}
                sx={{
                  border: 1,
                  p: 2,
                  bgcolor: 'background.paper',
                  cursor: 'pointer',
                  width: '100%',
                  color: '#d32f2f',
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <DeleteIcon sx={{ color: '#d32f2f', marginRight: '8px' }} />
                {t(TRANSLATIONS.TITLES.DELETE_ACCOUNT) || 'Delete Account'}
              </Box>
            )}
            <Box
              onClick={() => {
                handleClose();
                handleLogout();
              }}
              sx={{
                border: 1,
                p: 2,
                bgcolor: 'background.paper',
                cursor: 'pointer',
                width: '100%',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <LogoutIcon sx={{ color: '#600DB4', marginRight: '8px' }} />
              {t(TRANSLATIONS.TITLES.LOGOUT)}
            </Box>
          </Popover>
        </div>
      </nav>

      <div className="home-open-drawer">
        <span className="nav-brand">
          <img
            src={BRANDLOGO}
            alt="logo"
            className="nav-brand-img"
            onClick={() => {
              trackGAEvent({
                category: ANALYTICS_CATEGORIES.NAVIGATION,
                action: 'vREfyd_logo_inmobile_click',
                label: `vREfyd_logo_inmobile`,
              });
              sendAnalyticsEventToServer(`vREfyd_logo_inmobile_click`);
              navigate(HOME);
              dispatch(userActions.setRecomendationFilters({}));
            }}
          />
        </span>
        <Box sx={{ display: 'flex', flexDirection: 'row' }}>
          <span
            className="nav-button"
            style={{ position: 'relative' }}
            onClick={() => {
              trackGAEvent({
                category: ANALYTICS_CATEGORIES.NOTIFICATION,
                action: 'notification_inmobile_click',
                label: `notification_icon_inmobile`,
              });
              sendAnalyticsEventToServer(`notification_inmobile_click`);
              getNotifications();
              setOpenNotificationModal((val) => !val);
              handleClose();
            }}
          >
            <img src={NOTIFY} width={16} height={16} alt="notification" />
            {notificationsCount > 0 && (
              <span
                style={{
                  position: 'absolute',
                  background: '#600DB4',
                  top: '-10px',
                  right: '-10px',
                  width: '16px',
                  height: '16px',
                  borderRadius: '50%',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  fontSize: '12px',
                  color: '#fff',
                }}
              >
                {notificationsCount}
              </span>
            )}
          </span>

          <span
            className="nav-button"
            onClick={handleClick}
            aria-describedby={id}
          >
            <img src={PROFILE} alt="profile" />
          </span>

          <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            sx={{
              display: 'none',
              '.MuiBox-root': {
                border: 'none',
                borderRadius: '10px',
                boxShadow: '1px 1px 7.3px 0px rgba(185, 185, 185, 0.25)',
                cursor: 'pointer',
                alignItems: 'center',
                width: '100%',
              },
            }}
            className="home-profile-content"
          >
            <Box
              onClick={() => handleLogout()}
              sx={{
                borderBottom: '1px solid #D2D2D2 ',
                p: 2,
                bgcolor: 'background.paper',
                cursor: 'pointer',
              }}
            >
              {t(TRANSLATIONS.TITLES.AGENT_ID)} : {userId}{' '}
              <ContentCopyIcon sx={{ color: '#474747' }} />
            </Box>
            <Box
              onClick={() => handleLogout()}
              sx={{
                border: 1,
                p: 2,
                bgcolor: 'background.paper',
                cursor: 'pointer',
              }}
              className="home-profile-content"
            >
              {t(TRANSLATIONS.TITLES.LOGOUT)}
            </Box>
          </Popover>

          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            className="home-menu-icon"
            onClick={handleDrawerToggle}
            sx={{ mx: 2, ml: { lg: 2, xs: 0 }, display: { xmd: 'none' } }}
          >
            <img src={MENU} alt="Menu" style={{ width: 25, height: 25 }} />
          </IconButton>
        </Box>
      </div>

      <HomeSidebar open={openSidebar} setOpen={setOpenSidebar} />

      <Notifications
        open={openNotificationModal}
        onClose={() => setOpenNotificationModal(false)}
        notifications={notifications}
        getNotifications={getNotifications}
        isLoading={isLoading}
        notificationsCount={notificationsCount}
        setNotificationsCount={setNotificationsCount}
      />

      <LanguageModal
        open={openLanguageModal}
        onClose={() => setOpenLanguageModal(false)}
      />

      <ConfirmDeleteAccountModal
        open={openDeleteAccountModal}
        onClose={() => setOpenDeleteAccountModal(false)}
      />

      {loader && <LoaderComponent />}
    </>
  );
};

export default Navbar;
